var _defs, _g, _path, _path2, _g2, _g3, _g4, _g5, _g6, _path3, _path4, _path5, _ellipse, _path6, _path7, _g7, _path8, _path9, _g8, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _line, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect, _path39, _path40, _path41, _polyline, _path42, _polyline2, _path43, _path44, _path45, _circle, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path54, _path55, _path56, _path57, _circle12, _circle13, _rect2, _rect3, _rect4, _rect5, _path58, _path59, _path60, _path61, _circle14, _path62, _circle15, _path63, _polygon, _polygon2, _polygon3, _path64, _path65, _g9, _polygon4, _path66, _path67, _path68, _path69, _path70, _path71, _polygon5, _rect6, _polygon6, _rect7, _rect8, _polygon7, _rect9, _rect10, _polygon8, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path72, _path73, _path74, _g10, _path75;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecruitmentSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1502.96 991.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7e96a8;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-4 {\n        fill: #dd9828;\n      }\n\n      .cls-5 {\n        fill: #6dacea;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19 {\n        fill-rule: evenodd;\n      }\n\n      .cls-20 {\n        fill: #011e3b;\n      }\n\n      .cls-6 {\n        fill: #2c5484;\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-7 {\n        fill: #ffc9a9;\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-23 {\n        fill: #039;\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-27 {\n        fill: #3db884;\n      }\n\n      .cls-28 {\n        stroke: #3d7f7d;\n        stroke-width: .57px;\n      }\n\n      .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39 {\n        fill: none;\n      }\n\n      .cls-28, .cls-32, .cls-33, .cls-34, .cls-40 {\n        stroke-linejoin: round;\n      }\n\n      .cls-8 {\n        fill: #f5a475;\n      }\n\n      .cls-41, .cls-11, .cls-42, .cls-43, .cls-40 {\n        fill: #fff;\n      }\n\n      .cls-44 {\n        fill: #383838;\n      }\n\n      .cls-29 {\n        stroke-width: .37px;\n      }\n\n      .cls-29, .cls-31, .cls-35, .cls-36, .cls-37, .cls-39 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-29, .cls-31, .cls-36, .cls-37 {\n        stroke: #fff;\n      }\n\n      .cls-29, .cls-36, .cls-37 {\n        stroke-linecap: round;\n      }\n\n      .cls-45 {\n        opacity: .39;\n      }\n\n      .cls-9 {\n        fill: #231f20;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-10, .cls-46, .cls-31, .cls-42, .cls-43, .cls-32, .cls-47, .cls-15, .cls-16, .cls-18, .cls-48 {\n        isolation: isolate;\n      }\n\n      .cls-10, .cls-46, .cls-49, .cls-15, .cls-18, .cls-48 {\n        opacity: .43;\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-51 {\n        fill: #ffb62d;\n      }\n\n      .cls-52 {\n        fill: #cfdae2;\n      }\n\n      .cls-53 {\n        fill: #efb5a5;\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-12 {\n        fill: #1d3663;\n      }\n\n      .cls-13 {\n        fill: #e3e3e3;\n      }\n\n      .cls-46 {\n        fill: #bad1e2;\n      }\n\n      .cls-55 {\n        opacity: .88;\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-57 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-58 {\n        fill: #f2f2f2;\n      }\n\n      .cls-59 {\n        fill: #2a4f84;\n      }\n\n      .cls-31 {\n        stroke-dasharray: 3.06 13.13;\n        stroke-width: 1.75px;\n      }\n\n      .cls-31, .cls-16 {\n        opacity: .15;\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-42 {\n        opacity: .75;\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-14 {\n        fill: #f7f2f3;\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-63 {\n        fill: #e4e9f4;\n      }\n\n      .cls-43, .cls-47 {\n        opacity: .25;\n      }\n\n      .cls-32 {\n        opacity: .54;\n        stroke-dasharray: 3.06;\n        stroke-width: .88px;\n      }\n\n      .cls-32, .cls-33, .cls-40 {\n        stroke: #b7cbf9;\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-33, .cls-40 {\n        stroke-width: 1.13px;\n      }\n\n      .cls-65 {\n        fill: #a9bcc9;\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-67 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-47, .cls-68 {\n        fill: #ccc;\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-70 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-34 {\n        stroke: #ce7d67;\n        stroke-width: .85px;\n      }\n\n      .cls-72 {\n        fill: #ffd9d7;\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-73 {\n        fill: #e4f2f4;\n      }\n\n      .cls-74 {\n        opacity: .45;\n      }\n\n      .cls-35 {\n        stroke: #4b4e54;\n        stroke-width: .68px;\n      }\n\n      .cls-75 {\n        fill: #ce8d80;\n      }\n\n      .cls-36 {\n        stroke-width: .5px;\n      }\n\n      .cls-37 {\n        stroke-width: .82px;\n      }\n\n      .cls-76 {\n        fill: #ffa4a4;\n      }\n\n      .cls-77 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-78 {\n        fill: #f4ad9a;\n      }\n\n      .cls-38 {\n        stroke: #2c5484;\n        stroke-miterlimit: 22.93;\n        stroke-width: 1.88px;\n      }\n\n      .cls-79 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-80 {\n        fill: #70cacd;\n      }\n\n      .cls-39 {\n        stroke: #19417c;\n        stroke-width: .75px;\n      }\n\n      .cls-48 {\n        fill: #a0b2bc;\n      }\n\n      .cls-81 {\n        fill: #e29b74;\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-83 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-19 {\n        fill: #3c65d1;\n      }\n\n      .cls-84 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-85 {\n        fill: #031423;\n      }\n\n      .cls-86 {\n        opacity: .5;\n      }\n\n      .cls-87 {\n        fill: #d35400;\n      }\n\n      .cls-88 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-89 {\n        fill: #e7edf2;\n      }\n\n      .cls-90 {\n        fill: #383a45;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1164.87,877.02c42.68,5.11,76.62,47.76,77.8,75.94h-155.54c0-40.09,30.55-81.59,77.75-75.94Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 320.87,
    y1: -4606.39,
    x2: 368.89,
    y2: -4606.39,
    gradientTransform: "translate(0 -3833.36) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4279e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5fb7b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 235.47,
    y1: -4618.12,
    x2: 353.19,
    y2: -4618.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 231.46,
    y1: -4651.05,
    x2: 320.12,
    y2: -4651.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M340.9,816.59c-69.54,8.32-124.85,77.8-126.7,123.73h253.41c0-65.3-49.77-132.94-126.71-123.73Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 623.95,
    y1: -4730.37,
    x2: 1060.11,
    y2: -4116.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 642.04,
    y1: -4744.84,
    x2: 1078.2,
    y2: -4131.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1020.18,
    y1: -4373.01,
    x2: 1143.56,
    y2: -4147.12,
    gradientTransform: "translate(0 -3833.36) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4279e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5fb7b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 632.31,
    y1: -4739.38,
    x2: 745.51,
    y2: -4532.1,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1023.19,
    y1: -4245.94,
    x2: 1077.41,
    y2: -4146.66,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1053.9,
    y1: -4374.65,
    x2: 1093.4,
    y2: -4302.3,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 688.02,
    y1: -4619,
    x2: 731.07,
    y2: -4540.15,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1092.46,
    y1: -4381.26,
    x2: 1146.68,
    y2: -4282,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 625.25,
    y1: -4628.82,
    x2: 690.08,
    y2: -4510.13,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 576.94,
    y1: -4520.24,
    x2: 595.04,
    y2: -4520.24,
    gradientTransform: "translate(1774.43 -3713.53) rotate(22.5) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 652.69,
    y1: -4409.59,
    x2: 672.03,
    y2: -4409.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 947.88,
    y1: -4272.88,
    x2: 967.22,
    y2: -4272.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 847.83,
    y1: -4673.54,
    x2: 867.17,
    y2: -4673.54,
    gradientTransform: "translate(0 -3833.36) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d35400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb62d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 663.67,
    y1: -4553.71,
    x2: 722.5,
    y2: -4470.97,
    gradientTransform: "translate(0 -3833.36) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 793.68,
    y1: -4619.24,
    x2: 833.63,
    y2: -4563.04,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1116.23,903.56c31.2,3.73,56.01,34.93,56.84,55.57h-113.68c0-29.37,22.34-59.7,56.84-55.57Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1204.58,
    y1: -4716.59,
    x2: 1252.26,
    y2: -4716.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1174.33,
    y1: -4668.11,
    x2: 1218.32,
    y2: -4668.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1144.49,
    y1: -4702.29,
    x2: 1202.95,
    y2: -4702.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1177.56,
    y1: -4771.63,
    x2: 1229.73,
    y2: -4771.63,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1174.72,
    y1: -4752.31,
    x2: 1232.55,
    y2: -4752.31,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 121.33,
    y1: -429.85,
    x2: 149.04,
    y2: -429.85,
    gradientTransform: "translate(627.33 -126.77) scale(1 -1)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 112.08,
    y1: -429.85,
    x2: 213.66,
    y2: -429.85,
    gradientTransform: "translate(623.27 -137.89) scale(1 -1)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 374.04,
    y1: 584.82,
    x2: 387.39,
    y2: 584.82,
    gradientTransform: "translate(350.38 929.23) scale(1 -1)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 369.58,
    y1: 584.82,
    x2: 418.53,
    y2: 584.82,
    gradientTransform: "translate(347.25 922.73) scale(1 -1)",
    xlinkHref: "#linear-gradient-16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 829.14,
    y: 719.9,
    width: 45.31,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 829.14,
    y: 743.03,
    width: 67.97,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 863.12,
    y: 766.21,
    width: 51.17,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 935.25,
    y: 789.39,
    width: 68.44,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1013.88,
    y: 789.39,
    width: 57.03,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 863.12,
    y: 789.39,
    width: 24.15,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 828.05,
    y: 812.57,
    width: 25.2,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 864.61,
    y: 812.57,
    width: 69.27,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 828.05,
    y: 835.75,
    width: 31.05,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 872.88,
    y: 835.75,
    width: 26.37,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 914.29,
    y: 835.75,
    width: 44.03,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 972.48,
    y: 835.75,
    width: 44.03,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 828.05,
    y: 858.93,
    width: 25.2,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 867.41,
    y: 858.93,
    width: 66.48,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 828.05,
    y: 882.11,
    width: 25.2,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 862.77,
    y: 882.11,
    width: 25.2,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 896.02,
    y: 882.11,
    width: 25.2,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 931.09,
    y: 882.11,
    width: 54.46,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 992.93,
    y: 882.11,
    width: 36.39,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 887.27,
    y: 719.9,
    width: 57.73,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 955.44,
    y: 719.9,
    width: 66.48,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1032.51,
    y: 719.9,
    width: 76.75,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1121.29,
    y: 719.9,
    width: 36.29,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 984.32,
    y: 694.75,
    width: 27.17,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 896.97,
    y: 789.39,
    width: 27.17,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 907.21,
    y: 743.03,
    width: 27.17,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 923.66,
    y: 766.21,
    width: 27.17,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1021.93,
    y: 694.75,
    width: 13.56,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1044.19,
    y: 694.75,
    width: 35.21,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1089.89,
    y: 694.75,
    width: 38.83,
    height: 14.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 964.68,
    y: 742.08,
    width: 19.96,
    height: 19.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1000.06,
    y: 742.08,
    width: 19.96,
    height: 19.96
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1164.87,877.02c42.68,5.11,76.62,47.76,77.8,75.94h-155.54c0-40.09,30.55-81.59,77.75-75.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1164.87,877.02c42.68,5.11,76.62,47.76,77.8,75.94h-155.54c0-40.09,30.55-81.59,77.75-75.94Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 1155.35,
    y1: 870.97,
    x2: 1161.03,
    y2: 960.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 1158.19,
    y1: 914.72,
    x2: 1187.1,
    y2: 879.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 1140.37,
    y1: 957.96,
    x2: 1103.19,
    y2: 893.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 1131.44,
    y1: 877.7,
    x2: 1126.35,
    y2: 933.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 1128.15,
    y1: 962.32,
    x2: 1089.17,
    y2: 929.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 1103.65,
    y1: 941.87,
    x2: 1086.81,
    y2: 939.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 1157.38,
    y1: 902.75,
    x2: 1138.44,
    y2: 870.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 1207.9,
    y1: 884.48,
    x2: 1163.78,
    y2: 956
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 1225.2,
    y1: 902.89,
    x2: 1178.59,
    y2: 932
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 1234.49,
    y1: 918.63,
    x2: 1190.07,
    y2: 957.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 1242.62,
    y1: 935.82,
    x2: 1209.47,
    y2: 940.78
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 310.89,
    cy: 590.46,
    r: 35.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 275.43,
    cy: 592.58,
    r: 15.46
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M363.72,844.02c3.18-19.89,5.76-39.99,5.06-60.13-.7-20.13-5.14-44.26-15.61-61.92-6.03-10.21-27.5-34.33-31.75-8.18-2.13,12.94,3.18,25.01,6.95,37.09,3.62,11.56,8.88,22.78,11.96,34.5,4.92,18.72,8.05,37.87,13.61,56.41"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M353.19,854.31c-5.21-25.02-11.24-49.76-21.62-72.27-8.67-18.77-20.89-37.48-37.22-50.98-10.99-9.08-43.57-31.32-55.57-13.45-9.65,14.46,3.92,32.04,13.38,42.6,13.56,15.11,29.32,28.07,42.55,43.58,15.27,17.91,28.37,37.58,44.45,54.87"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M313.82,840.83c-13.45-16.57-29.11-31.21-46.53-43.52-5.89-4.14-35.9-24.5-35.82-4.67,0,13.61,16.32,21.43,26.36,26.7,20.64,10.86,43.06,18.69,62.3,31.93"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M241.01,796.22s41.44,18.42,84.81,61.79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M259.74,731.92s48.19,26.1,91.91,133.13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M332.73,719.74s27.83,39.26,27.83,139.05"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-58",
    cx: 438.86,
    cy: 940.33,
    rx: 239.29,
    ry: 8.49
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M340.9,816.59c-69.54,8.32-124.85,77.8-126.7,123.73h253.41c0-65.3-49.77-132.94-126.71-123.73Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M340.9,816.59c-69.54,8.32-124.85,77.8-126.7,123.73h253.41c0-65.3-49.77-132.94-126.71-123.73Z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 356.43,
    y1: 806.73,
    x2: 347.19,
    y2: 951.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 351.81,
    y1: 878.05,
    x2: 304.7,
    y2: 821.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 380.83,
    y1: 948.49,
    x2: 441.43,
    y2: 844.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 395.41,
    y1: 817.72,
    x2: 403.68,
    y2: 909.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 400.77,
    y1: 955.62,
    x2: 464.3,
    y2: 902.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 440.69,
    y1: 922.28,
    x2: 468.14,
    y2: 918.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 353.13,
    y1: 858.54,
    x2: 384.01,
    y2: 806.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 270.81,
    y1: 828.75,
    x2: 342.7,
    y2: 945.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 242.59,
    y1: 858.76,
    x2: 318.56,
    y2: 906.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 227.46,
    y1: 884.41,
    x2: 299.86,
    y2: 948.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 214.21,
    y1: 912.42,
    x2: 268.25,
    y2: 920.52
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M624.24,753.08h-40.03c-24.07,0-43.58,19.51-43.58,43.58v.02h0c0,24.07,19.51,43.58,43.58,43.58h509.04c24.07,0,43.58-19.51,43.58-43.58h0c0-24.07-19.5-43.59-43.57-43.6h-190.7c-18.2,0-32.96-14.76-32.96-32.96v-.02h0c0-18.2,14.74-32.97,32.94-32.98h314.6c24.15,0,43.73-19.56,43.74-43.71,0-.03,0-.06,0-.1h0c0-24.15-19.56-43.73-43.71-43.74h-280.94c-19.05,0-34.5-15.45-34.5-34.5h0c0-19.05,15.45-34.48,34.5-34.48h104.64c5.64,0,11.23-1.04,16.48-3.08"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1015.82,439.52h-388.98c-5.18,0-17.91,11.37-18.61,26.16-.74,15.16,10.96,28.05,26.12,28.78.44.02.89.03,1.33.03h115.28c22.42,0,40.6,18.18,40.6,40.6h0c0,22.42-18.16,40.6-40.58,40.61h-220.69c-30.75,0-55.68,24.93-55.68,55.68h0c0,30.75,24.93,55.68,55.68,55.68h216.91c18.2,0,32.96,14.76,32.96,32.96v.02h0c.05,18.19-14.65,32.99-32.85,33.04-.04,0-.07,0-.11,0h-15.11"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M239.2,290.75h57.16c8.99,0,11.76-.29,20.73,0,.1-5.54-1.44-10.75-4.1-13.54-2.32-2.39-5.71-3.42-8.97-2.73-3.86,1.02-6.48,3.6-8.99,5.53-.89-7.62-4.03-14.56-7.41-16.08-5.83-2.6-11.92,1.59-14.65,5.54-2.19,3.37-3.54,7.22-3.94,11.22-3.6-4.05-11.78-7.08-14.72-.73-.96,2.61-1.28,5.42-.94,8.18-4.88-1.27-10.07-.31-14.18,2.62Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M248.25,335.24h153.88c24.15,0,31.61-.59,55.73,0,.27-11.34-3.87-22.01-10.99-27.74-6.94-5.07-15.65-7.09-24.12-5.6-10.4,2.1-17.46,7.4-24.2,11.34-2.38-15.62-10.86-29.85-19.96-32.94-15.65-5.35-32.02,3.18-39.37,11.35-5.7,6.44-9.39,14.41-10.61,22.93-9.84-8.27-31.75-14.59-39.69-1.46-3.18,5.16-2.84,11.11-2.54,16.75-12.95-2.65-26.42-.75-38.14,5.38Z"
  }))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M582.96,504.14c3.91-4,15.69-9.64,20-11.32,2.56-1,7.14-2.48,7.94-1.48,1.86,2.59-6.24,3.76-5.29,5.08.57.79,5.99-1.59,8.78-2.71,2.49-1.06,6-2.14,7.08-.79,1.4,1.75-12.61,7.56-12.61,7.56,0,0,15-5.49,16.1-3.99,1.59,2.19-13.5,7.75-13.5,7.75,0,0,12.88-4.45,14.05-2.83s-8.81,4.25-12.46,6.13c2.92-.71,11.54-2.67,11.61-1.22.06,1.44-5.51,3.29-6.83,3.91-7.39,3.51-15.33,5.74-23.47,6.59"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M603.23,498.48c-.5,1.22-1.15,2.38-1.95,3.43-.8,1.05-1.7,2.03-2.68,2.91-1,.88-2.11,1.64-3.3,2.24-1.2.62-2.51.95-3.86.98,2.2-1.23,4.25-2.71,6.11-4.41,1.91-1.65,3.68-3.43,5.68-5.14Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M417.06,868.41l3.18,49.49-.17,17.34,59.46,4.25c1.59,0,2.21-5.3,1.06-5.75l-36.87-15.67,4.76-45.9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M418.21,920.6s-.46-4.02,1.43-4.02,2.03,1.79,4,2.32c3.72.97,11.94.1,19.21-2.45.9-.3.73-3.75,3.4-3.75s2.13,4.13,4.94,5.45c2.81,1.32,24.83,12.37,30.8,14.94,5.06,2.18,8.49,8.86-.38,8.86h-64.73c-.77,0-1.4-.63-1.4-1.4h0v-3.94c.55-5.4,1.46-10.75,2.73-16.02Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M459.66,922.26c-.85.48-1.63,1.06-2.32,1.75-.33.32-.64.66-.92,1.02-.17.21-.32.43-.44.67-.06.11-.11.22-.16.33-.06.21-.06.43,0,.64.08.29.39.47.68.4.26-.1.5-.27.67-.49.19-.19.36-.39.51-.6h0l.11-.14.19-.24.46-.51c.3-.3.62-.62.94-.9.32-.29.33-.3.52-.44s.13-.1,0,0h.08l.3-.22c.3-.19.4-.58.22-.89-.18-.3-.57-.39-.87-.22l.03-.13Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M456.63,919.63c-1.11.69-2.11,1.53-2.98,2.49-.45.51-.86,1.04-1.25,1.59-.45.54-.73,1.19-.81,1.89,0,.29.22.53.51.54.1,0,.2-.02.28-.07.15-.09.28-.19.4-.32l.32-.44.51-.76c.32-.51.65-1,1.02-1.48.76-1,1.59-1.94,2.49-2.81.13-.17.1-.42-.08-.56-.12-.09-.27-.11-.4-.05v-.02Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M365.02,868.41l-2.75,49.49-.19,17.34,59.46,4.25c1.59,0,2.22-5.3,1.06-5.75l-36.85-15.67,10.75-45.92"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M360.27,920.6s-.48-4.02,1.43-4.02,2.03,1.79,3.99,2.32c3.73.97,11.94.1,19.23-2.45.89-.3.71-3.75,3.4-3.75s2.11,4.13,4.92,5.45c2.81,1.32,24.83,12.37,30.8,14.94,5.06,2.18,8.49,8.86-.37,8.86h-64.75c-.76,0-1.38-.62-1.38-1.38,0,0,0-.01,0-.02v-3.94c.54-5.4,1.45-10.75,2.73-16.02Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M401.71,922.26c-1.23.7-2.31,1.64-3.18,2.76-.18.2-.34.43-.46.67-.05.11-.1.23-.16.33-.06.21-.06.43,0,.64.08.29.37.47.67.4.27-.1.5-.27.68-.49.18-.19.34-.39.49-.6h0l.11-.14.21-.24c.14-.17.3-.33.46-.51s.6-.62.92-.9l.52-.44h.08l.3-.22c.3-.19.4-.58.24-.89-.19-.3-.58-.4-.89-.22v-.13Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M398.69,919.63c-1.11.69-2.12,1.53-3,2.49-.44.51-.86,1.03-1.25,1.59-.45.54-.73,1.19-.81,1.89,0,.29.22.53.51.54.1,0,.2-.02.28-.07.15-.09.28-.19.4-.32.12-.14.22-.29.32-.44l.48-.75c.31-.51.65-1,1.02-1.48.75-1,1.58-1.94,2.48-2.81.15-.14.17-.38.02-.54-.12-.14-.33-.16-.48-.06l.05-.03Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M568.56,507.69c1.02-.38,15.62-6.84,15.62-6.84l13.59,17.99-24.64,10.15"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M428.67,542.19s1.76-37.91,9.14-41.28c22.85-10.4,57.68,24.12,74.46,19.59,26.4-7.16,65.21-18.27,65.21-18.27l15.88,25.82s-75.97,29.17-83.64,29.17c-19.67,0-41.07-14.29-41.07-14.29"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M431.03,621.18s-2.13,39.69-6,77.38c-10.11,88.42-27.13,208.79-27.13,208.79h-41.9s6.35-133.02,9.53-200.95c.94-20.53,1.59-46.04,22.91-75.89"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M468.79,630.51c13.46,123.08-14.8,276.84-14.8,276.84h-41.85l8.76-193.35s-15.5-62.01-5.64-90.5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M408.79,804.65s19.88-109.55,19.88-152.53"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M435.51,652.12s-2.86,37.69-8.34,37.69"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M362.49,907.36l12.7-200.95s5.48-41.01,22.91-75.89"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 417.95,
    y1: 907.5,
    x2: 423.59,
    y2: 762.7
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M387.23,525.3c4.06-24.99,7.35-22.07,22.97-27.45,5.68-.77,11.41-.98,17.13-.6,2.94.37,5.85.9,8.73,1.59,6.49,8.37,25.53,33.09,27.86,70.71,1.81,29.53,4.54,85.1,4.54,85.1,0,0-55.57,6.83-90.31-4.21-.02-29.64,3.16-88.75,9.07-125.14Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M410.2,497.85c6.11,33.12,5.59,79.38,1.59,180.85-13.94-2.11-41.2-6.35-41.2-6.35,0,0,1.24-119.58,5.19-132.13,7.13-22.37,34.42-42.37,34.42-42.37Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M436.07,498.83s12.13-2.43,8.19,183.26c10.81,0,24.02-2.86,31.12-7.21.98-49.36-1.78-98.72-8.27-147.65l-31.04-28.4Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M475.38,674.89s-5.72-109.9-6.68-128.81"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M435.3,485.43l2.45,16.31s0,6.8-12.81,6.18c-10.19-.51-11.11-.76-13.05-2.56-.56-.55-.84-1.32-.75-2.1l-1.24-33.17"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M443.59,464.52c0-.94,1.19-1.48,2.13-1.37,1.38.2,2.56,1.07,3.18,2.32.59,1.22.9,2.55.9,3.91.13,1.25-.05,2.52-.52,3.68-1.09,2.04-3.53,2.95-5.68,2.11"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M442.02,446.82s8.49,29.55,4.37,35.74c-6.21,9.29-21.45,10.34-27.97,6.35-5.48-3.41-10.35-22.23-10.46-27.17-.32-13.4,26.88-21.78,34.07-14.92Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M395.41,446.15c1.74-6.55,6.08-12.1,12-15.38,2.39-1.52,5.23-2.19,8.05-1.89,2.29.4,4.38,1.75,6.7,1.76,1.98-.19,3.91-.77,5.67-1.7,4.79-1.91,10.05-2.33,15.08-1.19,1.92.3,3.7,1.2,5.1,2.56,4.59,5.21-.52,13.03-4.91,16.51-6.18,4.89-14.86,4.92-22.32,5.99-1.58.11-3.12.56-4.52,1.3-3.51,2.21-3.52,7.21-3.18,11.34.39,3.59-.43,7.22-2.33,10.29-1.08,1.95,0,6.35-.27,9.84-5.34-4.14-9.69-9.43-12.7-15.48-3.75-7.41-4.59-15.95-2.37-23.94Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M434.13,490.29s-8.13,1.22-14.05-1.59c-5.68-2.75-7.8-9.72-7.8-9.72"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M415.52,469.16c-.96-1.31-2.43-2.15-4.05-2.3-1.21.22-2.3.88-3.06,1.86-3.79,4.48.65,12.7,6.6,11.69,2.19-.38,1.59-3.27,1.59-3.27"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M441.85,475.99l-13.75,2.27s2.29,7.02,8.92,5.92c5.91-1,4.83-8.19,4.83-8.19Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M406.73,708.07c.58.41,1.11.87,1.59,1.4.55.56.95,1.24,1.17,1.98.03.14.03.29,0,.43,0,.19-.06.37-.16.52-.05.13-.14.24-.24.33l-.21.22c-.28.32-.62.59-1,.78-.82.38-1.75.44-2.6.16-1.4-.57-2.61-1.52-3.51-2.73-.87-1.09-1.63-2.27-2.27-3.51,1.12.78,2.18,1.64,3.18,2.57.9.85,1.95,1.54,3.1,2.03.45.17.94.17,1.38,0,.24-.09.46-.22.65-.4l.16-.14s.16-.13.1,0,0,0,0,0v-.08c-.09-.59-.27-1.17-.56-1.7l-.78-1.87Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 349.8,
    y: 639.94,
    width: 97.58,
    height: 68.14,
    transform: "translate(-269.28 265.21) rotate(-27.93)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M448.13,668.29l-17.93-33.82h0l3.53-1.87c1.29-.68,2.88-.19,3.56,1.09h0l15.46,29.16c.68,1.29.19,2.88-1.09,3.56h0l-3.53,1.87h0Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M445.13,641.69c-2.94,1.28-4.28,4.69-3.01,7.62,1.28,2.94,4.69,4.28,7.62,3.01,2.94-1.28,4.28-4.69,3.01-7.62-.06-.14-.12-.27-.19-.4-1.33-2.77-4.66-3.93-7.43-2.6ZM446.56,644.37c1.28-.81,2.98-.42,3.79.86.81,1.28.42,2.98-.86,3.79-1.28.81-2.98.42-3.79-.86-.04-.06-.07-.12-.11-.18-.73-1.26-.3-2.87.96-3.6,0,0,0,0,0,0Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M385.91,681.43l6.53,12.11s7.18,2.6,10.16,7.41c1.01,1.61,2.1,3.16,3.27,4.65l4.95-2.37s.64,7.03-.92,8.59c-1.18.72-2.58,1.01-3.95.83.32,1.49-.63,2.96-2.12,3.28-.51.11-1.04.07-1.53-.11,1.48,2.65-1.84,5.06-4.65,2.25.25,2.94-2.81,3.94-5.68,3.18-3.18-.9-8.11-3.65-10.11-7.03-2-3.38-4.48-8.38-4.48-8.38l-6.35-11.97"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-51",
    points: "388.26 670.51 390.88 679.11 366.34 699.39 360.78 680.53"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M396.2,552.4c-5.1,17.15-16.27,53.68-16.27,53.68l9.99,68.27-31.96,22.35s-9.43-75.45-9.43-95.47,12.7-62.52,23.12-88.64c4.18-10.49,28.58-12.38,38.56-14.69"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-28",
    points: "383.71 631.83 380.53 606.08 394.96 558.74"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M843.18,735.01c-7.02-25.82-21.62-48.95-41.91-66.38l-.24-.17c-1.59-1.43-3.37-2.83-5.1-4.16l-.13-.08c-21.2-16.43-46.88-26.05-73.65-27.61-2.64-.17-5.32-.25-7.94-.25-73.79.04-133.57,59.89-133.52,133.68.04,73.79,59.89,133.57,133.68,133.52,73.79-.04,133.57-59.89,133.52-133.68,0-11.78-1.57-23.5-4.65-34.87h-.06ZM714.15,866.19c-53.11,0-96.16-43.06-96.16-96.17,0-53.11,43.06-96.16,96.17-96.16,21.51,0,42.39,7.21,59.32,20.48.76.64,1.59,1.27,2.32,1.89,40.72,34.08,46.1,94.72,12.02,135.44-18.25,21.81-45.22,34.41-73.65,34.44l-.02.08Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M932.25,253.62c-137.88,0-249.65,111.76-249.66,249.63,0,74.58,33.33,145.25,90.89,192.68.76.64,1.59,1.27,2.32,1.89,107.43,86.45,264.6,69.43,351.05-38,86.45-107.43,69.43-264.6-38-351.05-44.38-35.71-99.64-55.17-156.6-55.16ZM932.25,715.5c-47.52.08-93.67-15.87-131-45.26l-.24-.17c-1.59-1.43-3.37-2.83-5.1-4.16h-.13c-89.82-75.31-101.59-209.18-26.28-299,75.31-89.82,209.18-101.59,299-26.28,89.82,75.31,101.59,209.18,26.28,299-40.3,48.07-99.81,75.85-162.54,75.88h0Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M801.03,668.46c-1.71-1.35-3.43-2.73-5.1-4.16,1.73,1.33,3.45,2.73,5.1,4.16Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 714.15,
    cy: 770.04,
    r: 115.77
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M831.21,711.34c114.78,55.88,253.13,8.13,309.01-106.65,55.88-114.78,8.13-253.13-106.65-309.01-114.78-55.88-253.13-8.13-309.01,106.65-37.55,77.12-29.3,168.69,21.42,237.86"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1084.82,484.34h-14.45c-1.36-.66-2.21-2.05-2.21-3.56-.16-2.37-.56-4.76-.81-7.03-.02-.48-.36-.89-.83-1-2.73-1.06-5.45-2.18-8.14-3.37-.41-.26-.94-.21-1.29.13-2.02,1.59-4.06,3.18-6.11,4.76-1.17,1.12-3.03,1.08-4.15-.1-.06-.06-.11-.12-.17-.19-2.86-2.83-5.68-5.67-8.53-8.51-1.28-1.02-1.49-2.89-.47-4.17.06-.08.13-.15.2-.23,1.59-2.02,3.18-4.03,4.76-6.03.34-.34.41-.87.17-1.29-1.17-2.71-2.31-5.45-3.41-8.22-.1-.43-.48-.74-.92-.76-2.54-.27-5.08-.62-7.62-.9-1.67,0-3.03-1.36-3.03-3.03,0-.09,0-.19.01-.28v-11.96c-.18-1.67,1.02-3.18,2.7-3.36.12-.01.23-.02.35-.02,2.54-.29,5.08-.64,7.62-.9.56,0,.71-.32.9-.79,1.1-2.71,2.19-5.45,3.37-8.13.26-.45.19-1.01-.17-1.38-1.59-1.98-3.18-4-4.76-6.02-1.13-1.19-1.09-3.07.1-4.2.05-.05.1-.09.15-.14,2.86-2.88,5.72-5.74,8.59-8.57,1.04-1.26,2.9-1.44,4.16-.4.06.05.12.1.18.16,2.05,1.59,4.08,3.18,6.1,4.76.33.31.82.37,1.21.13,2.73-1.17,5.47-2.31,8.22-3.41.48-.19.73-.37.78-.92.29-2.54.62-5.06.9-7.6,0-1.68,1.35-3.05,3.04-3.06.09,0,.18,0,.26.01h12.05c1.67-.16,3.15,1.07,3.3,2.73,0,.1.01.2.01.3.29,2.51.62,5,.89,7.51.01.51.37.95.87,1.06,2.7,1.06,5.38,2.17,8.05,3.33.43.27,1,.21,1.37-.14,2.01-1.62,4.04-3.21,6.1-4.76,1.19-1.1,3.05-1.03,4.15.17.04.04.07.08.1.12,2.88,2.84,5.74,5.69,8.59,8.57,1.27,1.04,1.46,2.91.42,4.18-.04.05-.09.11-.14.16-1.59,2.05-3.18,4.08-4.76,6.1-.32.32-.38.81-.16,1.21,1.17,2.76,2.29,5.54,3.48,8.3.16.34.46.59.83.68,2.37.35,4.76.7,7.13.87,1.52-.02,2.91.85,3.56,2.22v14.29c-.66,1.37-2.04,2.23-3.56,2.22-2.35.16-4.68.56-7.03.83-.48,0-.89.34-1,.81-1.08,2.71-2.19,5.43-3.37,8.13-.25.44-.18,1,.17,1.37,1.59,1.98,3.18,4,4.76,6.02,1.14,1.16,1.12,3.02-.04,4.15-.06.06-.13.12-.2.18l-8.59,8.57c-1.06,1.26-2.95,1.42-4.21.35-.04-.04-.09-.08-.13-.11-2.02-1.59-4.03-3.18-6.02-4.76-.37-.36-.93-.44-1.38-.17-2.65,1.15-5.32,2.27-8.03,3.33-.52.22-.83.4-.89,1.03-.25,2.35-.65,4.68-.83,7.03.08,1.57-.8,3.04-2.22,3.72ZM1102.51,434.58c0-13.74-11.14-24.88-24.88-24.88-13.74,0-24.88,11.14-24.88,24.88,0,13.72,11.11,24.85,24.83,24.88,13.74,0,24.89-11.13,24.93-24.88Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M691.59,855.25h-13.19c-1.25-.61-2.04-1.88-2.03-3.27-.14-2.16-.51-4.3-.75-6.46-.02-.43-.33-.8-.75-.9-2.51-.98-5-2.01-7.48-3.08-.37-.24-.86-.19-1.17.11-1.86,1.49-3.73,2.95-5.6,4.41-1.1,1.03-2.83.98-3.86-.11-.04-.05-.08-.09-.12-.14l-7.81-7.81c-1.18-.96-1.36-2.69-.4-3.86.05-.06.11-.13.16-.19,1.44-1.84,2.87-3.7,4.35-5.53.31-.32.37-.81.14-1.19-1.08-2.49-2.11-5.02-3.18-7.54-.1-.39-.45-.68-.86-.7-2.33-.25-4.65-.57-6.99-.83-1.54,0-2.79-1.26-2.79-2.8,0-.08,0-.17.01-.25v-10.97c-.2-1.54.88-2.95,2.42-3.15.13-.02.26-.02.39-.02,2.33-.25,4.65-.57,6.99-.83.51,0,.67-.29.83-.73.99-2.5,2.03-4.99,3.1-7.46.24-.41.17-.92-.16-1.25-1.48-1.83-2.92-3.68-4.37-5.53-1.03-1.1-.98-2.83.12-3.86.04-.04.08-.07.12-.11,2.62-2.64,5.26-5.27,7.94-7.94.95-1.15,2.65-1.32,3.8-.37.06.05.12.1.17.15l5.6,4.41c.3.29.76.33,1.11.11,2.49-1.06,5.02-2.11,7.54-3.18.43-.17.65-.33.71-.84.25-2.33.57-4.65.83-6.99,0-1.53,1.23-2.78,2.77-2.79.09,0,.18,0,.27.01h11.11c1.53-.15,2.89.97,3.04,2.5,0,.09.01.19.01.28.25,2.29.57,4.59.81,6.89.02.47.35.87.81.97,2.48.98,4.94,2.01,7.38,3.06.4.24.91.19,1.25-.13,1.84-1.49,3.72-2.95,5.59-4.41,1.09-1.01,2.8-.94,3.81.15.03.03.06.07.09.1,2.64,2.6,5.27,5.24,7.94,7.94,1.17.96,1.34,2.68.38,3.84-.04.05-.08.1-.12.14-1.46,1.87-2.92,3.75-4.41,5.6-.29.29-.35.74-.14,1.1,1.08,2.52,2.1,5.1,3.18,7.62.16.31.43.54.76.64,2.18.3,4.35.64,6.54.79,1.39-.02,2.67.77,3.27,2.03v13.19c-.59,1.28-1.89,2.1-3.3,2.08-2.16.16-4.3.52-6.45.76-.44,0-.82.3-.92.73-.98,2.51-2,5-3.08,7.46-.24.41-.18.93.16,1.27,1.47,1.82,2.92,3.66,4.35,5.51,1.04,1.08,1.02,2.8-.06,3.84-.05.05-.11.1-.16.15l-7.94,7.86c-.97,1.16-2.69,1.31-3.85.35-.05-.04-.09-.08-.14-.12-1.84-1.43-3.7-2.87-5.53-4.35-.34-.32-.85-.38-1.25-.14-2.45,1.06-4.91,2.06-7.37,3.05-.49.21-.76.37-.83.95-.22,2.16-.6,4.3-.76,6.46.04,1.41-.76,2.7-2.03,3.3ZM707.81,809.59c-.03-12.61-10.27-22.81-22.88-22.78-12.61.03-22.81,10.27-22.78,22.88.03,12.58,10.22,22.77,22.8,22.78,12.63,0,22.86-10.25,22.86-22.88Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1051.62,388.28h-6.35c-.6-.3-.98-.92-.97-1.59-.08-1.03-.25-2.06-.37-3.1,0-.21-.16-.39-.37-.43-1.19-.48-2.38-.97-3.57-1.48-.17-.13-.4-.13-.57,0-.87.71-1.78,1.41-2.68,2.11-.51.49-1.32.48-1.82-.03-.02-.03-.05-.05-.07-.08l-3.72-3.72c-.57-.46-.66-1.29-.2-1.85.02-.03.05-.06.07-.08.7-.89,1.38-1.78,2.1-2.65.13-.17.13-.4,0-.57-.51-1.19-1.02-2.4-1.49-3.6-.04-.2-.21-.34-.41-.33l-3.35-.4c-.74,0-1.33-.61-1.32-1.34,0-.04,0-.08,0-.12v-5.26c-.08-.74.46-1.41,1.2-1.48.05,0,.1,0,.15,0l3.33-.4c.25,0,.32-.14.4-.35.49-1.19.97-2.38,1.49-3.57.11-.2.08-.44-.08-.6-.71-.87-1.4-1.76-2.1-2.65-.5-.53-.47-1.37.06-1.86.02-.01.03-.03.05-.04l3.78-3.76c.46-.55,1.28-.62,1.83-.16.02.02.05.04.07.06l2.68,2.11c.15.12.37.12.52,0,1.21-.51,2.41-1.02,3.62-1.49.21-.1.32-.16.35-.41.11-1.11.27-2.22.4-3.33,0-.75.6-1.35,1.35-1.35.03,0,.07,0,.1,0h5.29c.73-.07,1.38.47,1.45,1.2,0,.04,0,.09,0,.13.13,1.11.29,2.21.4,3.3,0,.23.16.42.38.48,1.19.46,2.37.95,3.54,1.46.18.13.42.13.6,0,.87-.71,1.78-1.41,2.68-2.11.52-.48,1.33-.45,1.82.07.01.01.03.03.04.05l3.78,3.78c.56.47.64,1.3.17,1.86-.01.02-.03.03-.04.05-.7.89-1.4,1.79-2.11,2.68-.12.15-.12.37,0,.52.52,1.21,1.02,2.45,1.59,3.65.08.14.21.25.37.3,1.05.14,2.1.3,3.18.38.67-.02,1.29.36,1.59.97v6.35c-.29.61-.91.99-1.59.98-1.03,0-2.06.24-3.18.37-.21,0-.39.14-.44.35-.46,1.19-.95,2.4-1.48,3.57-.13.18-.13.42,0,.6.71.87,1.4,1.76,2.1,2.65.49.51.48,1.32-.03,1.82-.03.02-.05.05-.08.07-1.25,1.27-2.51,2.52-3.78,3.78-.47.56-1.3.62-1.86.15-.02-.01-.03-.03-.05-.04-.89-.7-1.78-1.38-2.65-2.1-.18-.14-.43-.14-.6,0-1.16.51-2.33.98-3.52,1.46-.24.1-.37.17-.4.46-.1,1.03-.29,2.05-.37,3.08,0,.63-.36,1.2-.92,1.49ZM1059.39,366.4c0-6.03-4.91-10.92-10.94-10.91-6.03,0-10.92,4.91-10.91,10.94,0,6.02,4.89,10.9,10.91,10.91,6.04,0,10.93-4.9,10.94-10.94Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1074.56,523.55h-4.6c-.43-.21-.71-.65-.7-1.13,0-.76-.19-1.51-.27-2.25,0-.15-.1-.29-.25-.32l-2.62-1.08c-.12-.1-.29-.1-.41,0-.64.52-1.29,1.03-1.95,1.59-.35.38-.94.41-1.32.06-.02-.02-.04-.04-.06-.06l-2.73-2.73c-.39-.35-.42-.96-.07-1.35.02-.02.04-.05.07-.07.49-.65,1-1.29,1.51-1.92.09-.12.09-.29,0-.41-.38-.87-.75-1.76-1.1-2.64-.03-.14-.16-.24-.3-.25l-2.43-.29c-.53,0-.97-.43-.97-.96,0-.03,0-.07,0-.1v-3.92c-.06-.53.32-1.01.85-1.07.04,0,.08,0,.12,0l2.44-.29c.14-.01.26-.12.29-.25.35-.87.71-1.75,1.08-2.6.1-.13.1-.31,0-.44-.52-.64-1.02-1.29-1.59-1.94-.36-.37-.35-.96.02-1.32.02-.02.04-.04.06-.06.92-.92,1.83-1.84,2.75-2.75.35-.41.96-.46,1.37-.11.01,0,.02.02.03.03l1.95,1.59c.11.08.27.08.38,0,.87-.38,1.75-.75,2.64-1.1.16,0,.24-.11.25-.3,0-.81.19-1.59.29-2.43,0-.53.43-.97.96-.97.03,0,.07,0,.1,0h3.86c.52-.05.99.33,1.04.85,0,.04,0,.08,0,.12.1.79.21,1.59.29,2.4.01.16.13.3.29.35.86.33,1.73.7,2.57,1.06.13.1.31.1.44,0l1.95-1.59c.38-.35.97-.33,1.32.05.01.02.03.03.04.05.92.9,1.83,1.83,2.75,2.75.41.33.46.93.13,1.34-.01.01-.02.03-.04.04l-1.59,1.95c-.08.11-.08.27,0,.38l1.13,2.67c.05.11.14.19.25.22.76.11,1.59.22,2.29.27.49,0,.93.28,1.14.71v4.6c-.21.44-.66.71-1.14.71-.75,0-1.49.17-2.25.25-.16,0-.29.12-.32.27-.35.87-.7,1.73-1.08,2.6-.1.12-.1.3,0,.43l1.59,1.94c.36.38.34.99-.04,1.35-.01.01-.03.02-.04.03l-2.76,2.75c-.36.38-.97.4-1.35.03-.01-.01-.02-.02-.03-.03l-1.94-1.59c-.13-.09-.3-.09-.43,0l-2.57,1.06c-.17,0-.27.13-.29.33,0,.75-.21,1.49-.27,2.25.05.52-.25,1.02-.73,1.22ZM1080.23,507.68c0-4.38-3.55-7.94-7.94-7.94s-7.94,3.55-7.94,7.94,3.55,7.94,7.94,7.94c4.38,0,7.94-3.55,7.94-7.94,0-.02,0-.03,0-.05v.05Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M710.58,766.32h-5.02c-.48-.22-.78-.71-.78-1.24,0-.83-.19-1.59-.29-2.46,0-.19-.1-.27-.29-.33l-2.84-1.17c-.13-.1-.31-.1-.44,0l-2.06,1.71c-.39.42-1.04.44-1.46.05-.05-.04-.09-.09-.13-.15l-2.97-2.97c-.46-.35-.55-1.01-.2-1.47.03-.04.07-.08.11-.12.56-.7,1.1-1.41,1.59-2.1.1-.14.1-.32,0-.46-.41-.95-.81-1.91-1.19-2.87-.04-.15-.17-.25-.32-.25l-2.67-.32c-.59,0-1.06-.49-1.05-1.08,0-.03,0-.06,0-.08v-4.13c-.06-.58.36-1.11.95-1.17.04,0,.08,0,.12,0l2.67-.32c.19,0,.24-.11.32-.29.38-.95.76-1.89,1.17-2.83.1-.15.1-.34,0-.49-.57-.68-1.11-1.4-1.67-2.1-.39-.41-.37-1.07.04-1.46.02-.02.04-.03.06-.05l3-3c.37-.44,1.02-.49,1.45-.13.02.02.04.03.05.05.71.56,1.43,1.11,2.13,1.68.13.1.3.1.43,0l2.87-1.17c.15-.05.25-.18.27-.33.1-.89.21-1.76.32-2.65-.01-.58.45-1.06,1.03-1.07.04,0,.08,0,.12,0h4.21c.59-.05,1.1.38,1.15.96,0,.03,0,.07,0,.1.1.87.22,1.75.3,2.62.01.18.14.33.32.37l2.79,1.16c.14.12.35.12.49,0l2.13-1.67c.41-.38,1.05-.36,1.44.05.01.01.03.03.04.05l3,2.98c.46.35.55,1.01.2,1.47-.03.04-.07.08-.11.12l-1.59,2.13c-.1.12-.1.29,0,.41.41.97.79,1.94,1.21,2.91.07.12.17.2.3.24.83.11,1.59.24,2.48.3.53,0,1.01.3,1.24.78v4.95c-.23.48-.71.78-1.24.76-.81,0-1.59.21-2.45.3-.17,0-.31.11-.35.27-.38.95-.78,1.91-1.17,2.84-.12.14-.12.34,0,.48l1.59,2.11c.42.39.44,1.04.05,1.46-.02.02-.03.03-.05.05l-3,2.98c-.37.44-1.04.5-1.48.12-.01,0-.02-.02-.03-.03-.71-.56-1.41-1.1-2.11-1.67-.14-.11-.34-.11-.48,0-.92.4-1.87.78-2.81,1.16-.17,0-.29.14-.3.37-.1.81-.24,1.59-.3,2.45-.02.51-.33.97-.79,1.17ZM716.74,748.97c0-4.8-3.87-8.69-8.67-8.7-4.8,0-8.69,3.87-8.7,8.67,0,4.8,3.87,8.69,8.67,8.7h.02c4.79,0,8.68-3.88,8.68-8.67Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1120.78,523.55h-6.35c-.6-.3-.98-.92-.97-1.59,0-1.03-.24-2.06-.37-3.1,0-.21-.14-.39-.35-.43-1.21-.48-2.4-.97-3.57-1.48-.17-.13-.4-.13-.57,0l-2.68,2.11c-.52.49-1.35.47-1.84-.05-.02-.02-.04-.05-.06-.07l-3.75-3.73c-.56-.46-.65-1.29-.18-1.85.02-.03.05-.06.07-.08.68-.89,1.38-1.78,2.08-2.65.13-.17.13-.4,0-.57-.52-1.19-1.02-2.4-1.51-3.6-.08-.22-.17-.32-.4-.33l-3.35-.4c-.75,0-1.34-.62-1.34-1.36,0-.03,0-.07,0-.1v-5.21c-.08-.74.46-1.41,1.2-1.48.05,0,.1,0,.15,0l3.35-.4c.24,0,.32-.14.4-.35.48-1.19.97-2.38,1.48-3.57.13-.18.13-.42,0-.6-.7-.87-1.4-1.76-2.08-2.65-.5-.52-.48-1.34.04-1.84.02-.02.05-.04.07-.06l3.78-3.76c.45-.55,1.27-.62,1.81-.17.03.02.05.05.08.07l2.71,2.13c.16.12.38.12.54,0,1.19-.52,2.4-1.02,3.6-1.49.22-.1.32-.17.35-.41.11-1.11.27-2.22.4-3.35,0-.74.59-1.34,1.33-1.34.04,0,.08,0,.12,0h5.3c.74-.06,1.39.49,1.46,1.23,0,.03,0,.07,0,.1.11,1.11.27,2.21.38,3.3.01.22.17.42.38.48,1.19.46,2.37.95,3.54,1.46.18.13.42.13.6,0l2.68-2.11c.53-.49,1.35-.46,1.84.07.01.01.02.03.03.04l3.78,3.78c.56.47.62,1.3.15,1.86-.01.02-.03.03-.04.05-.7.89-1.4,1.79-2.11,2.68-.12.15-.12.37,0,.52.51,1.21,1,2.43,1.59,3.65.07.15.2.26.37.3,1.03.14,2.08.3,3.18.38.68-.03,1.3.36,1.59.97v6.35c-.29.61-.91,1-1.59.98-1.03,0-2.06.24-3.1.35-.21.02-.38.16-.43.37-.48,1.2-.97,2.39-1.48,3.57-.12.19-.09.45.08.6l2.08,2.64c.5.51.49,1.32-.01,1.82-.03.03-.06.06-.1.09-1.25,1.27-2.51,2.52-3.78,3.76-.45.55-1.26.63-1.81.18-.03-.02-.05-.05-.08-.07-.89-.68-1.78-1.37-2.65-2.08-.18-.13-.42-.13-.6,0-1.17.51-2.35.98-3.54,1.46-.22.1-.37.17-.38.46-.11,1.03-.29,2.05-.37,3.08-.06.67-.52,1.24-1.16,1.46ZM1128.56,501.69c0-6.04-4.9-10.94-10.94-10.94-6.04,0-10.94,4.9-10.94,10.94,0,6.04,4.89,10.93,10.92,10.94,6.04,0,10.95-4.89,10.95-10.94h0Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M659.26,766.42h-7.56c-.72-.35-1.17-1.08-1.16-1.87-.08-1.22-.3-2.46-.43-3.68,0-.25-.18-.47-.43-.52-1.44-.57-2.86-1.16-4.29-1.76-.19-.16-.47-.16-.67,0l-3.18,2.52c-.65.59-1.65.55-2.24-.09-.01-.02-.03-.03-.04-.05l-4.48-4.48c-.67-.56-.76-1.56-.2-2.24.02-.03.05-.06.07-.08.83-1.06,1.59-2.13,2.49-3.18.18-.18.21-.46.08-.68-.62-1.43-1.21-2.87-1.79-4.32-.05-.23-.24-.39-.48-.4-1.33-.14-2.67-.33-4-.48-.88,0-1.59-.7-1.6-1.58,0-.06,0-.11,0-.17v-6.35c-.11-.87.52-1.66,1.39-1.77.07,0,.13-.01.2-.01,1.33-.14,2.67-.33,4-.48.29,0,.38-.16.48-.41.57-1.43,1.16-2.86,1.76-4.27.15-.23.11-.53-.1-.71-.84-1.05-1.67-2.11-2.49-3.18-.59-.65-.54-1.65.11-2.24.01,0,.02-.02.03-.03,1.49-1.59,3-3.02,4.51-4.51.58-.66,1.58-.73,2.24-.15.01,0,.02.02.03.03,1.08.84,2.16,1.68,3.18,2.52.19.15.45.15.64,0,1.44-.6,2.87-1.21,4.32-1.78.25-.11.38-.19.41-.49.14-1.33.33-2.67.48-4,0-.88.7-1.59,1.58-1.6.06,0,.11,0,.17,0h6.35c.87-.09,1.65.55,1.74,1.42,0,.06,0,.11,0,.17.14,1.32.33,2.64.46,3.95.02.26.2.49.46.56,1.41.56,2.83,1.14,4.22,1.75.23.14.53.11.73-.08,1.05-.86,2.13-1.68,3.18-2.52.66-.57,1.65-.5,2.22.14l4.52,4.51c.67.57.75,1.57.19,2.24-.01.02-.03.03-.04.05l-2.52,3.18c-.17.16-.21.42-.1.62.64,1.46,1.21,2.92,1.83,4.37.1.17.26.3.44.37,1.24.17,2.49.37,3.75.46.79-.01,1.52.44,1.86,1.16v7.56c-.34.72-1.06,1.17-1.86,1.16-1.24.1-2.46.3-3.7.43-.25,0-.47.18-.52.43-.56,1.43-1.16,2.86-1.76,4.27-.14.24-.1.54.1.73.84,1.03,1.67,2.1,2.49,3.18.59.65.55,1.65-.1,2.24,0,0-.02.02-.03.03l-4.51,4.73c-.58.66-1.58.73-2.24.15-.01,0-.02-.02-.03-.03-1.06-.83-2.13-1.59-3.18-2.49-.2-.19-.5-.22-.73-.08-1.4.6-2.81,1.17-4.22,1.75-.27.11-.43.21-.46.54-.13,1.24-.35,2.46-.44,3.7.02.79-.43,1.52-1.14,1.86ZM668.55,740.29c0-7.22-5.85-13.07-13.07-13.07-7.22,0-13.07,5.85-13.07,13.07,0,7.2,5.83,13.05,13.03,13.07,7.22,0,13.08-5.84,13.1-13.07Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 585.99,
    cy: 686.88,
    r: 9.05,
    transform: "translate(-218.25 276.53) rotate(-22.5)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 585.99,
    cy: 686.88,
    r: 9.05,
    transform: "translate(-218.25 276.53) rotate(-22.5)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-64",
    cx: 662.36,
    cy: 576.23,
    r: 9.67
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 662.36,
    cy: 576.23,
    r: 9.67
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 957.55,
    cy: 439.52,
    r: 9.67
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 957.55,
    cy: 439.52,
    r: 9.67
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 976.91,
    cy: 599.17,
    r: 9.67
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 976.91,
    cy: 599.17,
    r: 9.67
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-79",
    cx: 857.5,
    cy: 840.18,
    r: 9.67
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 857.5,
    cy: 840.18,
    r: 9.67
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M764.29,687.99c-38.21-23.36-87.49-17.24-118.82,14.77l-33.34-19.05c25.37-30.03,62.69-47.33,101.99-47.3,2.33,0,4.65.06,6.95.19.35.56.7,1.13,1.06,1.59,11.81,18.37,25.98,35.12,42.15,49.81Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M847.83,770.04c.02,15.1-2.53,30.09-7.54,44.33l-33.34-19.05c8.7-32.07.25-66.35-22.35-90.7,18.01,13.25,37.71,24.01,58.59,32.01l.44.16c2.8,10.86,4.22,22.04,4.21,33.26Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M857.5,903.07h0c-14.71,0-26.64-11.93-26.64-26.64v-26.64h26.64c14.71,0,26.64,11.93,26.64,26.64h0c0,14.71-11.93,26.64-26.64,26.64Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M866.55,604.27h0c0,22.11-17.92,40.03-40.03,40.03h-40.03v-40.03c0-22.11,17.92-40.03,40.03-40.03h0c22.11,0,40.03,17.92,40.03,40.03Z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 826.54,
    cy: 604.27,
    r: 28.58
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 857.5,
    cy: 876.51,
    r: 16.86
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 658.47,
    y: 364.59,
    width: 34.53,
    height: 34.53,
    rx: 2.81,
    ry: 2.81
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 540.63,
    y: 364.59,
    width: 112.57,
    height: 6.64,
    rx: 1.67,
    ry: 1.67
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 610,
    y: 374.72,
    width: 43.2,
    height: 6.64,
    rx: 1.67,
    ry: 1.67
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 561.65,
    y: 384.19,
    width: 91.55,
    height: 6.64,
    rx: 1.67,
    ry: 1.67
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M653.2,396.11h0c0,.88-.71,1.59-1.59,1.59-.03,0-.05,0-.08,0h-51.82c-.88.04-1.62-.63-1.67-1.51,0-.03,0-.05,0-.08h0c0-.88.71-1.59,1.59-1.59.03,0,.05,0,.08,0h51.82c.88-.04,1.62.63,1.67,1.51,0,.03,0,.05,0,.08Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M653.2,402.48h0c.05.88-.63,1.62-1.5,1.67-.05,0-.11,0-.16,0h-21.35c-.88.04-1.62-.63-1.67-1.5,0-.05,0-.11,0-.16h0c0-.88.71-1.59,1.59-1.59.03,0,.05,0,.08,0h21.35c.88-.04,1.62.63,1.67,1.51,0,.03,0,.05,0,.08Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M653.2,408.86h0c0,.88-.71,1.59-1.59,1.59-.03,0-.05,0-.08,0h-46.04c-.88.04-1.62-.63-1.67-1.51,0-.03,0-.05,0-.08h0c-.05-.88.63-1.62,1.5-1.67.05,0,.11,0,.16,0h46.04c.88-.04,1.62.63,1.67,1.5,0,.05,0,.11,0,.16Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M653.2,415.24h0c0,.88-.71,1.59-1.59,1.59-.03,0-.05,0-.08,0h-37.2c-.88,0-1.59-.71-1.59-1.59h0c0-.88.71-1.59,1.59-1.59h37.2c.88-.04,1.62.63,1.67,1.51,0,.03,0,.05,0,.08Z"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 675.73,
    cy: 381.85,
    r: 11.22
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1121.18,291.07c-.02-25.25,20.44-45.74,45.69-45.76,25.25-.02,45.74,20.44,45.76,45.69.02,25.25-20.44,45.74-45.69,45.76-7.5,0-14.88-1.83-21.5-5.35l-10.61,5.38,2.94-10.53c-10.51-8.66-16.6-21.58-16.59-35.2Z"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-81",
    cx: 1166.89,
    cy: 291.09,
    r: 22.67,
    transform: "translate(693.95 1396.84) rotate(-80.85)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M1152.04,308.17c9.41,8.25,23.72,7.31,31.97-2.1,8.25-9.41,7.31-23.72-2.1-31.97-4.14-3.63-9.47-5.63-14.98-5.62v22.59l-14.89,17.1Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "826.54 624.04 809.61 613.94 809.61 594.68 826.54 604.78 826.54 624.04"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "843.46 613.94 826.54 624.04 826.54 604.78 843.46 594.68 843.46 613.94"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "843.46 594.63 826.54 604.78 809.61 594.63 826.54 584.52 843.46 594.63"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1116.23,903.56c31.2,3.73,56.01,34.93,56.84,55.57h-113.68c0-29.37,22.34-59.7,56.84-55.57Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1116.23,903.56c31.2,3.73,56.01,34.93,56.84,55.57h-113.68c0-29.37,22.34-59.7,56.84-55.57Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1109.27,
    y1: 899.13,
    x2: 1113.42,
    y2: 964.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1111.34,
    y1: 931.12,
    x2: 1132.47,
    y2: 905.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1098.32,
    y1: 962.72,
    x2: 1071.14,
    y2: 915.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1091.79,
    y1: 904.05,
    x2: 1088.08,
    y2: 945.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1089.38,
    y1: 965.91,
    x2: 1060.88,
    y2: 942.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1071.47,
    y1: 950.97,
    x2: 1059.16,
    y2: 949.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1110.75,
    y1: 922.38,
    x2: 1096.9,
    y2: 899.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1147.68,
    y1: 909.01,
    x2: 1115.43,
    y2: 961.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1160.33,
    y1: 922.47,
    x2: 1126.24,
    y2: 943.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1167.11,
    y1: 933.98,
    x2: 1134.64,
    y2: 962.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 1173.06,
    y1: 946.54,
    x2: 1148.82,
    y2: 950.18
  })))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "1153.65 572.1 1147.17 571.21 1143.17 576.36 1145.63 582.41 1152.11 583.3 1156.11 578.15 1153.65 572.1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1082.03,569.74c1.3-.66,2.77-.94,4.22-.83l43.42,1c.47.05.92-.22,1.1-.67,3.84-6.72,12.4-9.06,19.13-5.23,2.56,1.46,4.6,3.7,5.82,6.38.13.27.22.56.4.98l-1-.16-10.42-1.71c-2-.51-4.03.7-4.53,2.7-.05.2-.09.41-.1.62-.32,1.84-.62,3.7-.92,5.54-.48,1.99.75,4,2.74,4.48.19.05.38.08.58.09l10.16,1.67c.44.07.85.21,1.24.43-.86.85-1.78,1.66-2.73,2.41-6.2,4.53-14.9,3.18-19.43-3.03-.6-.83-1.11-1.72-1.52-2.66-.16-.49-.66-.78-1.16-.68l-43.07.97c-1.31.15-2.63-.13-3.76-.79-1.29-.78-2.11-2.14-2.21-3.64-.11-1.45-.11-2.9,0-4.35.15-.76.38-1.51.7-2.22l1.37-1.32ZM1089.49,573.31c-1.21-1.27-3.22-1.31-4.49-.09-1.27,1.21-1.31,3.22-.09,4.49,1.21,1.27,3.22,1.31,4.49.09.03-.03.06-.06.09-.09,1.2-1.21,1.19-3.16-.02-4.36-.01-.01-.03-.03-.04-.04h.06Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1235.59,824.89c16.05-8.53,20.13,10.03,13.89,25.4-6.24,15.37-38.28,67.08-39.95,87.59-.65,7.94-2.13,7.08-3.4,1.49-6.33-27.78,7.35-102.74,29.45-114.49Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1201.59,754.46c-18.4-16.58-29.91,6.62-26.74,29.01,3.18,22.39,28.47,101.29,23.91,128.95-1.76,10.73.49,10.07,4,3.18,17.53-34.72,24.16-138.32-1.17-161.13Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1198.39,920.11c.4,1.03,1.27.52,2.44-1.19,19.18-63.9-10.7-159.39-10.8-159.7-.17-.53-.73-.82-1.25-.65-.52.16-.81.71-.65,1.23,0,0,0,0,0,0,.1.32,30.39,97.1,10.26,160.31Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1161.39,807.56c-17.85-7.76-20.64,12.38-12.7,28.26,7.94,15.88,46.41,68.38,49.9,90.12,1.37,8.43,2.87,7.37,3.76,1.32,4.43-30.18-16.42-108.99-40.96-119.69Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1200.23,931.74c.54.68,1.06.08,1.59-1.49-1.59-52.39-47.63-116.06-47.79-116.27-.25-.35-.74-.44-1.1-.19-.34.26-.43.74-.19,1.1.1.21,46.74,64.76,47.49,116.85Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1186.5 920.15 1220.77 920.15 1229.73 928.22 1222.41 956.38 1203.64 956.38 1184.86 956.38 1177.56 928.22 1186.5 920.15"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 1174.72,
    y: 909.67,
    width: 57.84,
    height: 18.54,
    rx: 2.84,
    ry: 2.84
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1229.73 928.22 1228.22 934.01 1179.07 934.01 1177.56 928.22 1229.73 928.22"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 748.66,
    y: 289.23,
    width: 27.7,
    height: 27.7,
    transform: "translate(-15.66 563.35) rotate(-40.17)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 772.32,
    y: 278.11,
    width: 6.73,
    height: 27.7,
    transform: "translate(-5.38 569.23) rotate(-40.17)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "761 294.09 753.49 300.42 755.22 310.11 764.48 313.44 771.99 307.09 770.26 297.42 761 294.09"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 724.41,
    y: 337.73,
    width: 13.35,
    height: 13.35,
    transform: "translate(5.69 700.65) rotate(-51.38)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 734.65,
    y: 331.24,
    width: 3.24,
    height: 13.35,
    transform: "translate(12.71 702.25) rotate(-51.38)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "729.53 340.3 726.58 344 728.31 348.42 732.99 349.11 735.95 345.42 734.22 341 729.53 340.3"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 850,
    y: 869,
    width: 15,
    height: 15,
    rx: 2.1,
    ry: 2.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 907.84,
    y: 655.98,
    width: 20.08,
    height: 20.08
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 548.47,
    y: 660.46,
    width: 20.08,
    height: 20.08
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 939.88,
    y: 644.28,
    width: 31.79,
    height: 31.79
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 983.64,
    y: 655.98,
    width: 20.08,
    height: 20.08
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 1019.25,
    y: 655.98,
    width: 20.08,
    height: 20.08
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M831.03,432.88c-.1-12.28,9.77-22.31,22.05-22.41,12.28-.1,22.31,9.77,22.4,22.05.04,4.82-1.49,9.53-4.36,13.41h0c-3.18,4.76-11.38,10.16-11.38,13.38v3.68c0,.73-.6,1.33-1.33,1.33h-10.4c-.73,0-1.33-.6-1.33-1.33v-3.64c0-3.18-8.22-8.61-11.38-13.38h0c-2.78-3.8-4.27-8.39-4.25-13.1Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M855.72,463.97c-.24-5.77-.14-11.55.32-17.31-1.86.21-3.74.21-5.6,0,.44,5.74.54,11.5.29,17.26h-.4c.24-5.76.14-11.53-.3-17.27-6.57-.92-9.53-4.64-10.05-8.16-.4-1.8.25-3.68,1.67-4.86.82-.47,1.8-.56,2.7-.27,1.76.61,3.2,1.91,3.99,3.6,1.21,2.97,1.91,6.13,2.06,9.34,1.89.21,3.81.21,5.7,0,.16-3.21.86-6.36,2.06-9.34.79-1.69,2.22-2.99,3.99-3.6.9-.29,1.88-.2,2.7.27,1.42,1.18,2.06,3.05,1.67,4.86-.52,3.52-3.48,7.24-10.05,8.16-.45,5.75-.55,11.52-.3,17.27l-.43.05ZM863.2,433.59c-.34,0-.68.05-1,.16-1.65.58-3,1.81-3.73,3.4-1.17,2.9-1.85,5.97-2,9.1,6.35-.9,9.11-4.45,9.62-7.8.36-1.65-.22-3.37-1.49-4.48-.42-.25-.9-.39-1.4-.38h0ZM843.21,433.59c-.49,0-.98.13-1.4.38-1.28,1.11-1.85,2.82-1.49,4.48.51,3.35,3.33,6.89,9.62,7.8-.15-3.13-.83-6.21-2-9.11-.73-1.59-2.08-2.82-3.73-3.4-.32-.1-.66-.15-1-.14h0Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M860.26,460.95h-14.11v6.72c-.01,1.12.3,2.23.9,3.18h0c1.11,1.75,3.04,2.81,5.11,2.81h2.08c2.07,0,4-1.06,5.11-2.81h0c.6-.95.92-2.05.9-3.18v-6.72Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "600.82 418.31 677.68 418.31 677.68 526.04 600.82 526.04 600.82 418.31 600.82 418.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M600.82,418.07h77.09v108.21h-.24s-76.86,0-76.86,0h-.24v-108.21h.24ZM677.44,418.55h-76.38v107.26h76.38v-107.26h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "601.62 429.61 676.85 429.61 676.85 457.41 601.62 457.41 601.62 429.61 601.62 429.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M609.86,426.29h21.61c1.05,0,1.91.86,1.91,1.91v21.61c0,1.05-.86,1.91-1.91,1.91h-21.61c-1.05,0-1.91-.86-1.91-1.91v-21.61c0-1.05.86-1.91,1.91-1.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M621.27,436.77c-3.23-1.57-6.6.04-6.93,4.87.04,4.86.66,8.09,1.6,10.08h7.34c3.09-4.1,4.38-11.84-2.01-14.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M630.07,451.72c0-.93,0-1.9,0-2.94-2.04-1-3.37-1.84-5.23-3.1-.04,2.53-.72,4.33-1.62,6.04h6.85ZM615.83,451.72c.14-1.82.39-3.64.84-4.74,0,0-4.18.53-5.4,1.86-.58.62-1.03,1.63-1.33,2.88h5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M627.59,451.72c.67-2.44,1.65-2.93,1.88-2.94,1.72-.09,2.73.9,3.27,2.46-.34.3-.78.49-1.27.49h-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M611.55,451.72l-.28-.27-.08-.08.04-.11c.18-.5,1.21-2.87,1.87-2.62-.65.45-1.34,2.19-1.51,2.63l.46.44h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M627.53,451.72c.01-.84.02-2.45-.09-2.82-.05-.17-.39-.55-.8-.97-.71-.72-1.6-1.51-1.68-1.54.61.17,1.48.84,1.93,1.3.44.45.81.88.88,1.11.12.41.11,2.06.1,2.92h-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M612.73,433.03c-1.93,4.89,3.21,12.48-.92,14.43-2.2,1.04-1.27,3.41-2.53,4.16.18.06.37.09.57.09h6.57c1.3-2.27,1.84-4.94,1.15-6.11-2.02-3.45,3.01-13.12,2.99-13.39-.02-.31,1.19-1.45,2.13-1.88,1.33-.61-7.23-4.23-9.97,2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M614.42,437.23s-.01.26.44,3.12c.45,2.85,2.49,5.79,4.36,6.21,1.87.42,4.35-2.51,5.14-4.38.79-1.87.65-3.48.63-5.05-.03-1.57-2.27-7.25-3.49-6.01-1.21,1.25-3.7,5.35-7.08,6.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M619.16,432.05s3.11,2.94,3.94,4.44c.85,1.54.19,3.24.36,5.14.14,1.57.3,3.89.99,4.88,2.09,3.02,4.31,1.27,7.25,3-1.53-4.43-3.9-.48-3.75-9.08.08-4.95-.9-10.54-5.36-10.35.04.33-3.79.13-3.79.13l.37,1.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M618.32,440.4c-.35.64-.08.99.07,1.13.26.23.09.39-.15.28-.36-.18-.8-.57-.3-1.52.52-1.01.87-1.76.36-2.93-.04-.22,1.22.87.02,3.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M618.36,442.83c.59,0,1.18-.02,1.68-.25.9-.42.46.35-.44.62-1.28.39-2.38-.38-1.24-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M616.7,437.67c.31-.02.58.21.6.52.02.31-.21.58-.52.6-.31.02-.58-.21-.6-.52-.02-.31.21-.58.52-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M621.11,437.49c.31-.02.58.21.6.52.02.31-.21.58-.52.6-.31.02-.58-.21-.6-.52-.02-.31.21-.58.52-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M617.41,436.48c.39-.24-.79-.97-1.58-.47-.31.19-.77.65-.09.48.52-.13.68-.19,1.23-.02.15.04.31.09.43.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M619.99,436.1c-.42-.19.66-1.06,1.51-.67.33.15.85.55.15.47-.53-.06-.7-.1-1.23.13-.14.06-.29.13-.43.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M623.59,443.03c-.43,1.81-2.74,4.04-4.27,3.7-1.02-.23-2.13-1.17-2.69-2.2,2.76,3.12,4.93,1.5,6.96-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M637.71,434.92v-.56h1.12v-.43h-1.12v-.52h1.26v-.45h-1.82v2.4h1.86v-.45h-1.31ZM641.79,433.5c-.28,0-.52.11-.67.3-.13-.2-.35-.3-.61-.3-.24,0-.44.08-.58.24v-.21s-.51,0-.51,0v1.85h.54v-.93c0-.33.17-.48.41-.48.22,0,.35.14.35.44v.98h.54v-.93c0-.33.17-.48.41-.48.22,0,.35.14.35.44v.98h.54v-1.06c0-.56-.32-.82-.76-.82h0ZM643.29,433.27c.2,0,.33-.13.33-.31,0-.16-.13-.29-.33-.29s-.33.13-.33.3c0,.17.13.3.33.3h0ZM643.03,435.37h.54v-1.85h-.54v1.85h0ZM644.06,435.37h.54v-2.55h-.54v2.55h0ZM645.36,433.27c.2,0,.33-.13.33-.31,0-.16-.13-.29-.33-.29s-.33.13-.33.3c0,.17.13.3.33.3h0ZM645.09,435.37h.54v-1.85h-.54v1.85h0ZM646.87,433.5c-.3,0-.59.08-.8.22l.19.37c.13-.11.34-.17.53-.17.29,0,.43.13.43.36h-.43c-.56,0-.79.23-.79.55,0,.32.26.56.69.56.27,0,.46-.09.56-.26v.23h.5v-1.05c0-.56-.33-.82-.89-.82h0ZM646.83,435.04c-.19,0-.3-.09-.3-.22,0-.12.08-.22.33-.22h.37v.19c-.06.17-.22.25-.39.25h0ZM651.05,435.37h.58l-1.07-2.4h-.55l-1.07,2.4h.57l.21-.52h1.12l.21.52h0ZM649.9,434.43l.38-.92.38.92h-.76ZM653.14,433.52v.91c0,.34-.18.5-.43.5-.24,0-.37-.14-.37-.45v-.96s-.54,0-.54,0v1.04c0,.57.33.83.79.83.23,0,.43-.09.57-.25v.22h.51v-1.85h-.54ZM655.52,432.82v.9c-.13-.15-.33-.22-.55-.22-.52,0-.92.37-.92.95,0,.58.4.95.92.95.25,0,.44-.08.58-.24v.21h.51v-2.55h-.54ZM655.06,434.96c-.27,0-.47-.19-.47-.51,0-.32.21-.51.47-.51.26,0,.47.19.47.51,0,.32-.21.51-.47.51h0ZM657.06,433.77v-.24h-.51v1.85h.54v-.87c0-.35.2-.51.49-.51.04,0,.08,0,.12,0v-.49c-.28,0-.5.09-.64.27h0ZM659.81,434.45c0-.59-.42-.96-.96-.96s-.99.4-.99.95.42.95,1.05.95c.33,0,.59-.1.76-.3l-.28-.31c-.13.12-.27.18-.46.18-.28,0-.48-.14-.53-.37h1.4s.01-.1.01-.14h0ZM658.85,433.9c.24,0,.42.15.45.38h-.91c.04-.24.21-.38.46-.38h0ZM661.45,433.52l-.52,1.25-.52-1.25h-.55l.8,1.86v.02c-.08.16-.16.23-.31.23-.11,0-.22-.04-.3-.12l-.2.38c.12.11.33.17.52.17.33,0,.59-.13.77-.58l.83-1.96h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M638.64,439.27l-.15-.36h-.84l-.15.36h-.34l.75-1.71h.34l.74,1.71h-.35ZM637.77,438.62h.6l-.3-.72-.3.72h0ZM640.33,437.96v1.31h-.32v-.24c-.09.17-.24.25-.45.25-.15,0-.26-.04-.35-.13-.08-.09-.13-.21-.13-.37v-.82h.32v.73c0,.09.02.16.07.22.05.05.12.08.21.08.1,0,.18-.04.24-.11.06-.07.09-.16.09-.27v-.65h.32ZM641.99,437.45v1.81h-.32v-.21c-.05.07-.11.13-.18.17-.07.04-.16.06-.26.06-.12,0-.23-.03-.33-.08-.09-.06-.17-.14-.22-.24-.05-.1-.08-.22-.08-.35,0-.13.03-.25.08-.35.05-.1.12-.18.22-.23.09-.06.2-.08.32-.08.1,0,.19.02.26.06.08.04.14.1.19.17v-.72h.32ZM641.3,439.01c.11,0,.2-.04.27-.11.07-.07.1-.17.1-.29,0-.12-.03-.21-.1-.29-.07-.07-.16-.11-.27-.11-.11,0-.2.04-.27.11-.07.07-.1.17-.11.29,0,.12.04.21.11.29.07.07.16.11.27.11h0ZM642.4,437.96h.32v1.31h-.32v-1.31h0ZM642.56,437.4c.05,0,.1.02.13.05.03.04.05.08.05.14,0,.05-.02.1-.05.13-.03.04-.08.05-.13.05-.05,0-.1-.02-.13-.05-.03-.04-.05-.08-.05-.13,0-.06.02-.1.05-.14.03-.04.08-.05.13-.05h0ZM643.88,439.19c-.1.06-.21.1-.33.1s-.2-.03-.28-.1c-.07-.07-.11-.16-.11-.29v-.65s-.18,0-.18,0v-.23s.18,0,.18,0v-.36h.32v.36h.37v.23h-.37v.59c0,.06.01.1.03.13.02.03.06.04.1.04.05,0,.11-.02.19-.05l.07.24h0ZM646,439.27l-.15-.36h-.84l-.15.36h-.34l.75-1.71h.34l.74,1.71h-.35ZM645.13,438.62h.6l-.3-.72-.3.72h0ZM647.39,438.37c-.09-.1-.2-.14-.34-.14-.11,0-.19.04-.26.11-.07.07-.1.16-.1.28,0,.12.03.21.1.28.07.07.15.11.26.11.16,0,.27-.05.35-.15l.2.16c-.06.08-.14.15-.23.2-.1.05-.21.07-.34.07-.13,0-.24-.03-.34-.08-.1-.06-.18-.13-.23-.23-.06-.1-.08-.22-.08-.35,0-.13.03-.25.08-.35.06-.1.13-.18.23-.23.1-.06.22-.08.35-.08.12,0,.23.02.32.06.09.04.17.1.23.18l-.19.18h0ZM648.72,438.37c-.09-.1-.2-.14-.34-.14-.11,0-.19.04-.26.11-.07.07-.1.16-.1.28,0,.12.03.21.1.28.07.07.15.11.26.11.16,0,.27-.05.35-.15l.2.16c-.06.08-.14.15-.23.2-.1.05-.21.07-.34.07-.13,0-.24-.03-.34-.08-.1-.06-.18-.13-.23-.23-.06-.1-.08-.22-.08-.35,0-.13.03-.25.08-.35.06-.1.13-.18.23-.23.1-.06.22-.08.35-.08.12,0,.23.02.32.06.09.04.17.1.23.18l-.19.18h0ZM649.73,437.95c.14,0,.25.03.36.08.1.06.18.13.24.23.06.1.09.22.09.35,0,.13-.03.25-.09.35-.06.1-.14.18-.24.23-.1.06-.22.08-.36.08-.14,0-.26-.03-.36-.08-.1-.06-.19-.13-.24-.23-.06-.1-.09-.22-.09-.35,0-.13.03-.25.09-.35.06-.1.14-.18.24-.23.1-.06.23-.08.36-.08h0ZM649.73,438.22c-.11,0-.2.04-.27.11-.07.07-.1.17-.1.29,0,.12.03.21.1.29.07.07.16.11.27.11.11,0,.2-.04.26-.11.07-.07.1-.17.1-.29,0-.12-.03-.21-.1-.29-.07-.07-.16-.11-.26-.11h0ZM651.9,437.96v1.31h-.32v-.24c-.09.17-.24.25-.45.25-.15,0-.26-.04-.35-.13-.08-.09-.13-.21-.13-.37v-.82h.32v.73c0,.09.02.16.07.22.05.05.12.08.21.08.1,0,.18-.04.24-.11.06-.07.09-.16.09-.27v-.65h.32ZM653.08,437.95c.15,0,.27.05.35.14.09.09.13.21.13.37v.82s-.32,0-.32,0v-.72c0-.09-.03-.16-.08-.22-.05-.05-.12-.08-.21-.08-.11,0-.19.04-.25.11-.06.07-.09.16-.09.27v.64s-.32,0-.32,0v-1.31h.32v.24c.09-.17.25-.25.47-.26h0ZM654.69,439.19c-.1.06-.21.1-.33.1s-.2-.03-.28-.1c-.07-.07-.11-.16-.11-.29v-.65s-.18,0-.18,0v-.23s.18,0,.18,0v-.36h.32v.36h.37v.23h-.37v.59c0,.06.01.1.03.13.02.03.06.04.1.04.05,0,.11-.02.19-.05l.07.24h0ZM655.71,439.27v-.16c-.05.06-.1.1-.18.13-.07.03-.15.04-.25.04s-.17-.02-.24-.05c-.07-.03-.12-.08-.16-.15-.04-.06-.06-.13-.06-.21,0-.12.04-.22.13-.29.09-.07.21-.1.37-.11h.38v-.03c0-.08-.03-.14-.08-.18-.05-.04-.12-.06-.22-.06-.12,0-.25.04-.39.12l-.11-.22c.1-.06.2-.1.28-.12.08-.03.18-.04.29-.04.17,0,.3.04.39.12.09.08.14.2.14.34v.86s-.31,0-.31,0h0ZM655.36,439.04c.09,0,.17-.02.23-.06.07-.04.1-.1.11-.16v-.12s-.33,0-.33,0c-.08,0-.15.01-.19.04-.04.03-.06.07-.06.12,0,.06.02.1.06.13.04.03.1.05.17.05h0ZM657.17,437.95c.15,0,.27.05.35.14.09.09.13.21.13.37v.82s-.32,0-.32,0v-.72c0-.09-.03-.16-.08-.22-.05-.05-.12-.08-.21-.08-.11,0-.19.04-.25.11-.06.07-.09.16-.09.27v.64s-.32,0-.32,0v-1.31h.32v.24c.09-.17.25-.25.47-.26h0ZM658.78,439.19c-.1.06-.21.1-.33.1s-.2-.03-.28-.1c-.07-.07-.11-.16-.11-.29v-.65h-.18v-.23s.18,0,.18,0v-.36h.32v.36h.37v.23h-.37v.59c0,.06.01.1.03.13.02.03.06.04.1.04.05,0,.11-.02.19-.05l.07.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M651.63,451c-.17-.25-.34-.52-.34-.83,0-.62.5-1.13,1.13-1.13s1.13.5,1.13,1.13c0,.31-.18.57-.34.83-.8,1.24-.76,1.23-1.57,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M652.41,449.81c.22,0,.4.18.4.4s-.18.4-.4.4c-.22,0-.4-.18-.4-.4,0-.22.18-.4.4-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M652.41,449.81c.22,0,.4.18.4.4s-.18.4-.4.4c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h0ZM638.93,449.56h2.57c.11,0,.2.09.2.2v1.39c0,.11-.09.2-.2.2h-2.57c-.11,0-.2-.09-.2-.2v-1.39c0-.11.09-.2.2-.2h0ZM641.65,449.63l-1.28,1.02c-.09.07-.22.07-.32,0l-1.28-1.02M664.73,449.05c.75,0,1.37.61,1.37,1.37s-.61,1.37-1.37,1.37c-.75,0-1.37-.61-1.37-1.37s.61-1.37,1.37-1.37h0ZM664.73,451.78v-2.73M664.73,449.05c.44,0,.8.61.8,1.37s-.36,1.37-.8,1.37c-.44,0-.8-.61-.8-1.37s.36-1.37.8-1.37h0ZM663.44,449.89h2.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "636.78 453.6 643.64 453.6 643.64 453.86 636.78 453.86 636.78 453.6 636.78 453.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "661.35 453.6 668.11 453.6 668.11 453.86 661.35 453.86 661.35 453.6 661.35 453.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "650.17 454.58 654.65 454.58 654.65 454.84 650.17 454.84 650.17 454.58 650.17 454.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "649.29 453.6 652.77 453.6 652.77 453.86 649.29 453.86 649.29 453.6 649.29 453.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "653.14 453.6 655.52 453.6 655.52 453.86 653.14 453.86 653.14 453.6 653.14 453.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "637.16 441.71 668.57 441.71 668.57 442.06 637.16 442.06 637.16 441.71 637.16 441.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "637.16 444.15 671.43 444.15 671.43 443.8 637.16 443.8 637.16 444.15 637.16 444.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "637.16 445.89 655.42 445.89 655.42 446.24 637.16 446.24 637.16 445.89 637.16 445.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "639.37 463.08 639.37 518.62 639.12 518.62 639.12 463.08 639.37 463.08 639.37 463.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "613.2 470.12 629.42 470.12 629.42 469.46 613.2 469.46 613.2 470.12 613.2 470.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "613.2 471.43 623.12 471.43 623.12 472.09 613.2 472.09 613.2 471.43 613.2 471.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "613.2 474.06 631.66 474.06 631.66 473.4 613.2 473.4 613.2 474.06 613.2 474.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "613.2 477.98 629.42 477.98 629.42 477.32 613.2 477.32 613.2 477.98 613.2 477.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "613.2 479.29 623.12 479.29 623.12 479.95 613.2 479.95 613.2 479.29 613.2 479.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "613.2 481.91 631.66 481.91 631.66 481.26 613.2 481.26 613.2 481.91 613.2 481.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "613.2 465.52 629.42 465.52 629.42 465.19 629.42 464.87 613.2 464.87 613.2 465.19 613.2 465.52 613.2 465.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M609.42,463.72c.81,0,1.47.66,1.47,1.47,0,.81-.66,1.47-1.47,1.47-.81,0-1.47-.66-1.47-1.47,0-.81.66-1.47,1.47-1.47h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "613.2 494.37 622.03 494.37 622.03 493.72 613.2 493.72 613.2 494.37 613.2 494.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "613.2 495.68 626.4 495.68 626.4 496.34 613.2 496.34 613.2 495.68 613.2 495.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "613.2 500.65 629.42 500.65 629.42 499.99 613.2 499.99 613.2 500.65 613.2 500.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "613.2 501.96 623.12 501.96 623.12 502.62 613.2 502.62 613.2 501.96 613.2 501.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "613.2 504.58 631.66 504.58 631.66 503.93 613.2 503.93 613.2 504.58 613.2 504.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "613.2 489.77 621.31 489.77 621.31 489.45 621.31 489.12 613.2 489.12 613.2 489.45 613.2 489.77 613.2 489.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M609.42,487.98c.81,0,1.46.66,1.46,1.46,0,.81-.66,1.46-1.46,1.46-.81,0-1.46-.66-1.46-1.46,0-.81.66-1.46,1.46-1.46h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "613.2 509.23 622.03 509.23 622.03 508.58 613.2 508.58 613.2 509.23 613.2 509.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "613.2 510.55 626.4 510.55 626.4 511.2 613.2 511.2 613.2 510.55 613.2 510.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "650.11 470.11 662.89 470.11 662.89 469.45 650.11 469.45 650.11 470.11 650.11 470.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "650.11 471.42 660.02 471.42 660.02 472.08 650.11 472.08 650.11 471.42 650.11 471.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "650.11 474.05 668.56 474.05 668.56 473.39 650.11 473.39 650.11 474.05 650.11 474.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "650.11 465.51 659.03 465.51 659.03 465.18 659.03 464.86 650.11 464.86 650.11 465.18 650.11 465.51 650.11 465.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M646.33,463.72c.81,0,1.46.66,1.46,1.46,0,.81-.66,1.46-1.46,1.46s-1.46-.66-1.46-1.46c0-.81.66-1.46,1.46-1.46h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "650.11 501.97 655.81 501.97 655.81 501.31 650.11 501.31 650.11 501.97 650.11 501.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "650.11 503.28 659.79 503.28 659.79 503.93 650.11 503.93 650.11 503.28 650.11 503.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "650.11 508.24 660.81 508.24 660.81 507.59 650.11 507.59 650.11 508.24 650.11 508.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "650.11 509.55 660.02 509.55 660.02 510.21 650.11 510.21 650.11 509.55 650.11 509.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "650.11 497.37 661.27 497.37 661.27 497.04 661.27 496.71 650.11 496.71 650.11 497.04 650.11 497.37 650.11 497.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M646.33,495.58c.81,0,1.46.66,1.46,1.46,0,.81-.66,1.46-1.46,1.46-.81,0-1.46-.66-1.46-1.46,0-.81.66-1.46,1.46-1.46h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "650.11 486.04 662.89 486.04 662.89 485.38 650.11 485.38 650.11 486.04 650.11 486.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "650.11 487.35 660.02 487.35 660.02 488.01 650.11 488.01 650.11 487.35 650.11 487.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "650.11 489.97 665.53 489.97 665.53 489.32 650.11 489.32 650.11 489.97 650.11 489.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "650.11 481.44 666.33 481.44 666.33 481.11 666.33 480.78 650.11 480.78 650.11 481.11 650.11 481.44 650.11 481.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M646.33,479.65c.81,0,1.46.66,1.46,1.46,0,.81-.66,1.46-1.46,1.46s-1.46-.66-1.46-1.46c0-.81.66-1.46,1.46-1.46h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-38",
    x1: 663.41,
    y1: 450.94,
    x2: 666,
    y2: 450.94
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M582.96,504.14c3.91-4,15.69-9.64,20-11.32,2.56-1,7.14-2.48,7.94-1.48,1.86,2.59-6.03,5.76-7.57,7.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitmentSelection);
export default __webpack_public_path__ + "static/media/recruitment-selection.519c0ef219cc18154be76fecd81481ea.svg";
export { ForwardRef as ReactComponent };